import React from 'react';
import { Link } from 'react-router-dom';
import vntgLogo from '../assets/vntg_logo.png';
import './Footer.css';

const Footer: React.FC = () => (
  <footer className="app-footer">
    <div className="footer-inner">
      <div className="footer-left">
        <img src={vntgLogo} alt="VNTG" className="footer-logo" />
        <div className="footer-divider" />
        <p className="footer-company">브이엔티지</p>
        <div className="footer-divider" />
        <a href="mailto:secu@vntgcorp.com" className="footer-email">secu@vntgcorp.com</a>
      </div>

      <div className="footer-right">
        <Link to="/privacy" target="_blank" rel="noreferrer" className="footer-privacy">
          개인정보 처리방침
        </Link>
        <p className="footer-copy">© {new Date().getFullYear()} 주식회사 브이엔티지</p>
      </div>
    </div>
  </footer>
);

export default Footer;
